import { useContext } from "react";
import { VideoStoreContext } from "../../app/context/VideoContext";

export const useVideoStore = () => {
    const store = useContext(VideoStoreContext);

    return store;
};
